<template>
  <RouterView />
</template>

<script>
import { RouterView } from 'vue-router'

export default {
  name: 'OutreachView',
  components: {
    RouterView,
  },
}
</script>
